import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MainSidebarService {
  private _openState$ = new BehaviorSubject(false);

  constructor() {}

  get openState$() {
    return this._openState$.asObservable();
  }

  updateState(state: boolean) {
    this._openState$.next(state);
  }
}
